import { getObjectLabel } from '../../../../../utils/StoreUtils'
import DtoPrettyAnalysisLight from '../../../dashboard/dto/DtoPrettyAnalysisLight'
import { groupBy, sumBy, keys } from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'
import { getSandreLabel } from '../../../../../utils/StringUtil'
import { SANDRE } from '../../../../../referencial/constants/ReferencialConstants'
import echarts from 'echarts/lib/echarts'
import ReactEchartsCore from 'echarts-for-react/lib/core'
import React from 'react'
import { SHOW_SANDRE_CODE } from 'account/constants/AccountSettingsConstants'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'
import PropTypes from 'prop-types'
import { whiteColor, grey } from 'utils/constants/ColorTheme'

import 'echarts/lib/chart/treemap'
import 'echarts/lib/chart/tree'

const getRemarkCodeWeight = (remark) => {
    switch (remark) {
        case '1':
            return 20
        case '2':
            return 1
        case '10':
            return 3
        case '7':
            return 5
        default:
            return 30
    }
}

const OperationTreeMapChart = ({
    analysis,
}) => {
    const {
        sandreCodes,
        parametersIndex,
    } = useSelector(store => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
        parametersIndex: store.ParameterReducer.parametersIndex,
    }), shallowEqual)

    const generalShowSandreCode = useApplicationSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : true)
    const showSandreCode = useAccountSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : generalShowSandreCode)

    const group = groupBy(analysis, 'remark')
    const chartData = keys(group).map(remark => {
        const remarkLabel = getSandreLabel(sandreCodes, SANDRE.REMARK_CODE, remark)
        const remarkWeight = getRemarkCodeWeight(remark)
        const childs = group[remark].map(ana => {
            const name = getObjectLabel(parametersIndex[ana.parameter], showSandreCode ? 'shortLabelWithCode' : 'shortLabel')
            return {
                value: remarkWeight,
                name,
                // path: `${remarkLabel}/${name}`,
            }
        })
        return {
            children: childs,
            value: sumBy(childs, 'value'),
            name: remarkLabel,
            // path: remarkLabel
        }
    })

    const options = {
        series: [
            {
                name: 'CodesRemarques',
                type: 'treemap',
                visibleMin: 0,
                // visibleMin: 300,
                label: {
                    show: true,
                    formatter: '{b}',
                },
                itemStyle: {
                    borderColor: whiteColor,
                },
                levels: [
                    {
                        // itemStyle: {
                        //     borderColor: '#777',
                        //     borderWidth: 0,
                        //     gapWidth: 1
                        // },

                    },
                    {
                        itemStyle: {
                            borderColor: whiteColor,
                            borderWidth: 5,
                            gapWidth: 1,
                        },
                        upperLabel: {
                            show: true,
                            color: grey,
                        },
                        // emphasis: {
                        //     itemStyle: {
                        //         borderColor: '#ddd'
                        //     }
                        // }
                    },
                ],
                data: chartData,
            },
        ],
    }
    return (
        <ReactEchartsCore
            echarts={ echarts }
            option={ options }
            notMerge={ true }
            lazyUpdate={ true }
            className={ 'row no-margin' }
            style={ { height: 450 } }
        />
    )
}

OperationTreeMapChart.propTypes = {
    analysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoPrettyAnalysisLight)),
}

export default OperationTreeMapChart